import { createApp } from 'vue';
import VCalendar from 'v-calendar';
import App from './App.vue';
import store from './store';
import router from './router';
import '@fortawesome/fontawesome-free/css/all.css';
import 'v-calendar/style.css';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import 'vue-loading-overlay/dist/css/index.css';
import { createHead } from '@vueuse/head'
import { createGtm } from '@gtm-support/vue-gtm';
import { createI18n } from 'vue-i18n'
import messages from './i18n'

const head = createHead()

const i18n = createI18n({
	locale: 'ro',
	messages: messages
})

// GTM Consent Mode v2 — set defaults before GTM loads
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
	event: 'consent_default',
	analytics_storage: 'denied',
	ad_storage: 'denied',
	functionality_storage: 'denied',
	personalization_storage: 'denied',
	wait_for_update: 500,
});
// If user previously accepted, grant consent immediately
if (localStorage.getItem('cookie_consent') === 'accepted') {
	window.dataLayer.push({
		event: 'consent_update',
		analytics_storage: 'granted',
		ad_storage: 'granted',
		functionality_storage: 'granted',
		personalization_storage: 'granted',
	});
}

const feather = require('feather-icons');
feather.replace();

createApp(App)
	.use(head)
	.use(router)
	.use(store)
	.use(VCalendar)
	.use(BackToTop)
	.use(i18n)
	.use(
		createGtm({
			id: "GTM-T9ZXH2LP",
			vueRouter: router
		})
		)
	.mount('#app');